import { render } from "./PageToolbarTitle.vue?vue&type=template&id=75384fa9"
import script from "./PageToolbarTitle.vue?vue&type=script&lang=js"
export * from "./PageToolbarTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToolbarTitle});
